export default __webpack_public_path__ + "static/media/blank-profile-picture-973460_1280.c3f94521.png";